<template>
    <div id="ritual-details" class="h-100">
        <div class="grid">
            <div class="col-12">
                <as-title class="title" :title="ritualDetails?.ritual?.libelle" :size="3" />
            </div>
            <div class="col-12 pb-0 mb-3 flex align-items-center">
                <img v-if="ritualDetails?.enterprise && ritualDetails?.enterprise.fichierDrapeau"
                    :src="ritualDetails?.enterprise.fichierDrapeau.url" class="drapeau-img mr-2" />
                <label class="mr-5">
                    {{ ritualDetails?.enterprise?.nom }}
                    <br />
                    <strong>
                        {{ ritualDetails?.ritual?.month.toString().padStart(2, '0') }} / {{ ritualDetails?.ritual?.year
                        }}
                    </strong>
                </label>
                <div class="flex align-items-center ml-5 mr-5">
                    {{ $t('rituals.ritual_details.ritual_canceled_label') }}
                    <Chip class="p-2 ml-2" :class="{ 'bg-error': ritualDetails?.ritual?.canceledBySafetyLeader }">
                        {{ $t('confirm_modal.' + (ritualDetails?.ritual?.canceledBySafetyLeader ? 'yes_button' :
                            'no_button')) }}
                        <i
                            :class="'ml-2 pi ' + (ritualDetails?.ritual?.canceledBySafetyLeader ? 'pi-check' : 'pi-times')"></i>
                    </Chip>
                </div>
                <div class="flex align-items-center ml-5">
                    {{ $t('rituals.ritual_details.ritual_delayed_label') }}
                    <Chip class="p-2 ml-2" :class="{ 'bg-error': ritualDetails?.ritual?.delayed }">
                        {{ $t('confirm_modal.' + (ritualDetails?.ritual?.delayed ? 'yes_button' : 'no_button')) }}
                        <i :class="'ml-2 pi ' + (ritualDetails?.ritual?.delayed ? 'pi-check' : 'pi-times')"></i>
                    </Chip>
                </div>
            </div>
        </div>
        <div class="grid mt-3">
            <RitualDetailsSubject v-for="(sujet, sujetIndex) in ritualDetails?.ritual?.rituelSujet" :key="sujet.id"
                :sujet="sujet" :index="sujetIndex" @download="onDownloadFichier" />
        </div>
        <div class="grid mt-3">
            <div class="col-12 pb-0 mb-0">
                <as-title class="title" :title="$t('rituals.ritual_details.textaera_label')" :size="4" />
            </div>
            <div class="col-12">
                <div class="w-100 note p-3">
                    {{ ritualDetails?.ritual?.champsLibre }}
                </div>
            </div>
        </div>
        <div class="grid fixed-bottom">
            <div class="col flex justify-content-end">
                <Button :label="$t('rituals.ritual_details.google_sheet_button_label')" class="button-default mr-2"
                    :icon="isSending ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'" @click="createRitualGoogleSheet"
                    :disabled="isSending" />
                <Button :label="$t('form.cancel_button')" class="button-default" :icon="'pi pi-times'"
                    @click="onClose" />
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters } from "vuex";

import AsTitle from "../Elements/AsTitle.vue";

import fichiersServiceApi from "../../services/fichiersServiceApi";
import { createRitualGoogleSheet } from "../../services/ritualServiceApi";

import Button from "primevue/button";
import Chip from "primevue/chip";
import RitualDetailsSubject from "./RitualDetailsSubject.vue";

export default {
    name: "RitualDetails",
    components: {
        AsTitle,
        Button,
        Chip,
        RitualDetailsSubject
    },
    props: {
        ritualDetails: {
            enterprise: Object,
            ritual: Object
        },
    },
    mixins: [fichiersServiceApi],
    emits: ["onClose"],
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    data() {
        return {
            isSending: false,
        }
    },
    methods: {
        onClose() {
            this.$emit("onClose");
        },
        onDownloadFichier(externalId, titre) {
            this.downloadFile(externalId, titre)
        },
        async createRitualGoogleSheet() {
            this.isSending = true
            const driveUrl = await createRitualGoogleSheet(this.ritualDetails.ritual.id)
            open(driveUrl)
            this.isSending = false
        },
    },
};
</script>
<style lang="scss">
#ritual-details {
    .p-card-header {
        height: 45px;

        >div {
            height: 100%;
            align-items: center;
        }
    }

    .note,
    .drapeau-img {
        border: 1px solid #dadada;
        border-radius: 10px;
    }

}
</style>
